
import { Options, prop, Vue } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import formatByCountry from "@/app/infrastructures/misc/common-library/FormatByCountry";

class Props {
  totalDelNow = prop<number>({
    default: 0
  });
  totalDelIntracity = prop<number>({
    default: 0
  });
  totalDelIntercity = prop<number>({
    default: 0
  });
  isLoading = prop<boolean>({
    default: false
  });
}

@Options({
  components: {
    OverlayPanel,
    Skeleton
  }
})
export default class HeaderSTTShouldDel extends Vue.with(Props) {
  toolTip1 = false;
  statusChipsStyle = true;

  toggleStatusPanel(event: any, name: string) {
    const refs: any = this.$refs;
    if (name === "tooltipStatus") {
      this.toolTip1 = !this.toolTip1;
    }
    refs[name].toggle(event);
  }

  get totalStt() {
    return formatByCountry(this.totalDelNow, { type: "quantity" });
  }

  get formattedIntracity() {
    return formatByCountry(this.totalDelIntracity, { type: "quantity" });
  }

  get formattedIntercity() {
    return formatByCountry(this.totalDelIntercity, { type: "quantity" });
  }

  onClickCard() {
    this.$router.push(
      "/sti-dest/need-to-sti-dest-del?filter-now=true&filter-overdue=false"
    );
  }
}
